module.exports = __webpack_public_path__ + "static/media/SocialPiper-Header-mobile.5a3baaa4.jpg";